// extracted by mini-css-extract-plugin
export default {"searchWrapper":"DataTableSearch_searchWrapper__SPtuX","searchIcon":"DataTableSearch_searchIcon__Pjoq1","searchInput":"DataTableSearch_searchInput__7QMbn"};